import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getContract = params => {
  return axios.request({
    url: "/user/contract",
    params,
    method: "get"
  });
};
export function updateFlie(data) {
  return axios.request({
    url: "/user/contract/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}
export const add = data => {
  return axios.request({
    url: "/user/contract",
    data,
    method: "post"
  });
};
export const update = data => {
  return axios.request({
    url: `/user/contract/${data.id}`,
    data,
    method: "put"
  });
};
export const del = id => {
  return axios.request({
    url: `/user/contract/${id}`,
    method: "delete"
  });
};

export const delBL = (type, id) => {
  return axios.request({
    url: `/user/contract/removeBL/${id}/${type}`,
    method: "delete"
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/user/contract/${id}`,
    method: "get"
  });
};

export const getContractParams = data => {
  return axios.request({
    url: "/user/contract/getContractParams",
    method: "post",
    data
  });
};

export const getContractFile = params => {
  return axios.request({
    url: "/user/contractFile",
    method: "get",
    params
  });
};

export const delContractFile = id => {
  return axios.request({
    url: `/user/contractFile/${id}`,
    method: "delete"
  });
};
